import { Button } from '@mui/material'
import React from 'react'
import { useDispatch } from 'react-redux'
import { auth, provider } from './firebase'
import {Loginto} from './features/userSlice'
import './Login.css'

function Login() {
    const dispatch = useDispatch();
    const signin = () =>{
        auth.signInWithPopup(provider)
        .then(({user}) => {
            dispatch(Loginto({
                displayName : user.displayName,
                email : user.email,
                photoUrl : user.photoURL,
            }));
        })
    .catch(error=> alert(error.message));    
    };

  return (
    <div className='login'>
        <div className='login_container'>
            <img src='https://upload.wikimedia.org/wikipedia/commons/7/7e/Gmail_icon_%282020%29.svg' alt=''></img>
            <Button className='login_button' variant='contained' color='primary' onClick={signin}>Login</Button>
        </div>
    </div>
  )
}

export default Login